function cov_bhqml9vu() {
  var path = "/__w/code/code/js/packages/cinderblocks/src/i18n/index.ts";
  var hash = "7ea27c4a43139252302c926513cc9afbc337a6cc";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/cinderblocks/src/i18n/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 9,
          column: 25
        },
        end: {
          line: 9,
          column: 41
        }
      },
      "1": {
        start: {
          line: 11,
          column: 0
        },
        end: {
          line: 37,
          column: 3
        }
      },
      "2": {
        start: {
          line: 29,
          column: 4
        },
        end: {
          line: 29,
          column: 71
        }
      },
      "3": {
        start: {
          line: 32,
          column: 4
        },
        end: {
          line: 34,
          column: 5
        }
      },
      "4": {
        start: {
          line: 33,
          column: 6
        },
        end: {
          line: 33,
          column: 57
        }
      },
      "5": {
        start: {
          line: 35,
          column: 4
        },
        end: {
          line: 35,
          column: 15
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 28,
            column: 21
          },
          end: {
            line: 28,
            column: 22
          }
        },
        loc: {
          start: {
            line: 28,
            column: 45
          },
          end: {
            line: 30,
            column: 3
          }
        },
        line: 28
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 31,
            column: 26
          },
          end: {
            line: 31,
            column: 27
          }
        },
        loc: {
          start: {
            line: 31,
            column: 35
          },
          end: {
            line: 36,
            column: 3
          }
        },
        line: 31
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 32,
            column: 4
          },
          end: {
            line: 34,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 32,
            column: 4
          },
          end: {
            line: 34,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 32
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "7ea27c4a43139252302c926513cc9afbc337a6cc"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_bhqml9vu = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_bhqml9vu();
import "core-js/modules/es.array.concat.js";
import { initReactI18next } from 'react-i18next';
import { createInstance } from 'i18next';
import enAccount from "./locales/en/account.json";
import esAccount from "./locales/es/account.json";

// Create an isolated i18next instance for CinderBlocks to avoid conflicts with consuming applications
var cinderBlocksI18n = (cov_bhqml9vu().s[0]++, createInstance());
cov_bhqml9vu().s[1]++;
cinderBlocksI18n.use(initReactI18next).init({
  fallbackLng: 'en',
  lng: 'en',
  defaultNS: 'account',
  ns: ['account'],
  resources: {
    en: {
      account: enAccount
    },
    es: {
      account: esAccount
    }
  },
  debug: false,
  // Set to true to log i18next events in the console (useful for troubleshooting missing keys, language loading, etc.)
  interpolation: {
    escapeValue: false
  },
  missingKeyHandler: function missingKeyHandler(lng, ns, key) {
    cov_bhqml9vu().f[0]++;
    cov_bhqml9vu().s[2]++;
    console.error("[i18n] Missing translation: [".concat(lng, "] ").concat(ns, ":").concat(key));
  },
  parseMissingKeyHandler: function parseMissingKeyHandler(key) {
    cov_bhqml9vu().f[1]++;
    cov_bhqml9vu().s[3]++;
    if (process.env.NODE_ENV !== 'production') {
      cov_bhqml9vu().b[0][0]++;
      cov_bhqml9vu().s[4]++;
      throw new Error("Missing translation key: ".concat(key));
    } else {
      cov_bhqml9vu().b[0][1]++;
    }
    cov_bhqml9vu().s[5]++;
    return key;
  }
});
export default cinderBlocksI18n;
//# sourceMappingURL=index.mjs.map